import Price from '../../../models/stripe/Price';
import HttpReference from '../../platform/HttpReference';
import StripePrices from './StripePrices';

export default class StripePrice extends HttpReference<Price, void, StripePrices> {}
